import { MenuDownIcon } from 'assests/GmsIcons';
import React, { useContext, useEffect, useRef } from 'react';
import { TMerchantData, TMerchantMenuProps } from '../analytics';
import useClickOutside from 'Components/GMS/CustomHooks/useClickOutside';
import { AppContext } from 'Context/AppContext';

const MerchantsMenu = ({ merchantData, selectedMerchant, setSelectedMerchant }: TMerchantMenuProps) => {
  const { showMenu, ref, handleClick } = useClickOutside();
  const appContext = useContext(AppContext);
  const channelKey = appContext?.channelKey;
  const prevChannelKeyRef = useRef<string | null>(null);

  useEffect(() => {
    if (!channelKey || channelKey === prevChannelKeyRef.current) return;            
    
    prevChannelKeyRef.current = channelKey;

    const matchingMerchant = merchantData?.find(
      (merchant: TMerchantData) => merchant?.merchant_key === channelKey
    );
    
    if (matchingMerchant && 
        (!selectedMerchant || 
          selectedMerchant.merchant_key !== matchingMerchant.merchant_key)) {
      setSelectedMerchant(matchingMerchant);
    }
  }, [channelKey, merchantData, selectedMerchant, setSelectedMerchant]);
  
  useEffect(() => {
    if (merchantData?.length > 0 && !selectedMerchant) {
      setSelectedMerchant(merchantData[0]);
      return;
    }
    
    if (selectedMerchant && merchantData?.length > 0) {
      const stillExists = merchantData.some(
        (merchant: TMerchantData) => merchant.merchant_key === selectedMerchant.merchant_key
      );
      
      if (!stillExists) {
        setSelectedMerchant(merchantData[0]);
      }
    }
  }, [merchantData, selectedMerchant, setSelectedMerchant]);

  const isSelectedMerchant = (merchant: TMerchantData): boolean => {
    return Boolean(
      selectedMerchant &&
      selectedMerchant?.merchant_key === merchant?.merchant_key &&
      selectedMerchant?.user_name === merchant?.user_name
    );
  };

  const handleMerchantSelection = (merchant: TMerchantData) => {
    setSelectedMerchant(merchant);
    handleClick();
  };

  const getSelectedMerchantName = (): string => {
    if (selectedMerchant) {
      return selectedMerchant?.user_name;
    }
    return "Select Channel";
  }

  return (
    <React.Fragment>
      <div ref={ref} className='tw-relative tw-bg-white tw-z-40'>
        <div onClick={handleClick} className={`${showMenu ? 'tw-bg-[#EBECF0]' : ''} hover:tw-bg-[#EBECF0] tw-p-2 tw-ms-3 tw-rounded-[4px] tw-flex flex-row tw-items-center tw-justify-center tw-gap-[6px]`}>
          <button className={`tw-text-sm tw-font-normal tw-text-[#172B4D]`}>
            {getSelectedMerchantName()}
            <span className='tw-ms-2'>
              <div className="tw-w-6 tw-h-6 tw-px-3 tw-py-0.5 tw-bg-zinc-200 tw-rounded-3xl tw-border tw-justify-center tw-items-center tw-gap-1 tw-inline-flex">
                <div className="tw-text-slate-600 tw-text-xs tw-font-normal">{selectedMerchant ? 1 : 0}</div>
              </div>
            </span>
          </button>
          <MenuDownIcon />
        </div>
        {showMenu ? <div className={`tw-origin-top-right tw-absolute tw-mt-1 tw-w-max tw-mx-3 tw-rounded-[4px] tw-bg-white tw-ring-1 tw-ring-[#EBECF0]`}>
          <div className={`tw-py-1 tw-text-left`} role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
            {merchantData && merchantData.length > 0 ? merchantData.map((merchant) => (
              <React.Fragment key={merchant.merchant_key + merchant.user_name}>
                <div
                  className={`tw-flex tw-justify-between tw-items-center tw-py-1 tw-px-2 hover:tw-bg-[#F4F5F7] tw-cursor-pointer ${isSelectedMerchant(merchant) ? 'tw-bg-[#F4F5F7]' : ''}`}
                  onClick={() => handleMerchantSelection(merchant)}
                >
                  <div className={`tw-flex tw-items-center`}>
                    <input
                      type="radio"
                      className={`tw-accent-[#091CAA]`}
                      checked={isSelectedMerchant(merchant)}
                      onChange={() => { }}
                      name="merchantRadio"
                    />
                    <label className={`tw-ms-2 tw-text-[#091E42] tw-text-sm`}>{merchant.user_name}</label>
                  </div>
                </div>
              </React.Fragment>
            )) : (
              <div className="tw-py-2 tw-px-4 tw-text-gray-500 tw-text-sm">No channels available</div>
            )}
          </div>
        </div> : null}
      </div>
    </React.Fragment>
  )
}

export default MerchantsMenu;